import { LoadingOutlined } from '@ant-design/icons';
import { Col } from 'antd';
import { get } from 'lodash-es';

import { BillingWrapper } from '@page/account-settings/account-plan/account-plan.style';
import { PageTitle, PageWrapper } from '@style/pages/page.style';

import { Row } from '@atom/grid/row/row';
import { Text, Title } from '@atom/typography/typography';
import { Billing } from '@component/billing/billing';
import { Chart } from '@component/chart/chart';
import { useCurrentApplication } from '@hook/application/use-current-application.hook';
import { useMedia } from '@hook/style/use-media.hook';
import { isExist } from '@util/data/is-exist';

import { ApplicationId } from './application-id/application-id';
import { DashboardLog } from './dashboard-log/dashboard-log';
import { DashboardStart } from './dashboard-start/dashboard-start';
import { DashboardStats } from './dashboard-stats/dashboard-stats';
import { DashboardCard, WrapperChart } from './dashboard.page-style';

export const DashboardPage = () => {
  const application = useCurrentApplication();
  const applicationId = get(application, ['current', 'id']);
  const { isMobile } = useMedia();

  return (
    <PageWrapper>
      <Text paragraph>
        Application ID: <ApplicationId id={applicationId} />
      </Text>
      <PageTitle>Dashboard</PageTitle>
      <Row gutter={[24, 24]} vertical>
        <DashboardStart />
        <Col id='dashboard-1' span={24}>
          <DashboardCard bordered={false}>
            <DashboardStats />
          </DashboardCard>
        </Col>
        <Col id='dashboard-2' span={24}>
          <DashboardCard
            bordered={false}
            title={
              <WrapperChart>
                <Title level={isMobile ? 5 : 4} weight={500}>
                  Total API Requests
                </Title>
              </WrapperChart>
            }
          >
            <Chart applicationId={applicationId} height={300} />
          </DashboardCard>
        </Col>
        <Col span={24}>
          <Row gutter={24}>
            <Col span={24}>
              <DashboardLog />
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <BillingWrapper>{isExist(application) ? <Billing /> : <LoadingOutlined />}</BillingWrapper>
        </Col>
      </Row>
    </PageWrapper>
  );
};
